// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"f090f719","3246":"65401883","4946":"24b8eca9"}[chunkId] + ".chunk.css";
};